import { render, staticRenderFns } from "./judicialExpertise.vue?vue&type=template&id=cdfd9596"
import script from "./judicialExpertise.vue?vue&type=script&lang=js"
export * from "./judicialExpertise.vue?vue&type=script&lang=js"
import style0 from "./judicialExpertise.vue?vue&type=style&index=0&id=cdfd9596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports